<div [style.height.px]="filterHeight" class="bg-white px-2 mb-4 transition-all duration-200 overflow-hidden">
  <div class="flex justify-between border-b border-gray-200 py-2">
    <div>
      <span class="text-base font-medium text-amazone-orange">Filters</span>
      <p class="text-xs text-gray-600">Search results will be immediately updated as you select or deselect filters.</p>
    </div>
    <button
      class="bg-white rounded-full hover:cursor-pointer hover:text-amazone-orange hover:scale-110 transition-all duration-300"
      (click)="closeFilters()"
      appAgentAction
      agent="error-message-filter-close"
      businessObject="errorMessage"
      action="close"
    >
      <app-close-icon></app-close-icon>
    </button>
  </div>
  <div class="flex flex-wrap gap-x-4 gap-y-2 items-start mt-4 overflow-y-auto max-h-[340px] px-1 pb-4">
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Search In</span>
      <div class="grid gap-3 mt-2">
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInCode"
            (change)="onScopeChanged()"
          />
          <span>Code</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInHeaderOnTerminal"
            (change)="onScopeChanged()"
          />
          <span>Header Terminal</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInDetailsOnTerminal"
            (change)="onScopeChanged()"
          />
          <span>Details Terminal</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInOtherFields"
            (change)="onScopeChanged()"
          />
          <span>Other Fields</span>
        </label>
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Categories</span>
      <div class="grid gap-3 mt-2">
        <label class="inline-flex items-center gap-1 text-xs text-gray-700">
          <input
            type="checkbox"
            [(ngModel)]="searchQuery.hasCategoryInfo"
            (change)="onScopeChanged()"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
          />
          <span>Info</span>
        </label>
        <label class="inline-flex items-center gap-1 text-xs text-gray-700">
          <input
            type="checkbox"
            [(ngModel)]="searchQuery.hasCategoryWarning"
            (change)="onScopeChanged()"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
          />
          <span>Warning</span>
        </label>
        <label class="inline-flex items-center gap-1 text-xs text-gray-700">
          <input
            type="checkbox"
            [(ngModel)]="searchQuery.hasCategoryAlert"
            (change)="onScopeChanged()"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
          />
          <span>Alert</span>
        </label>
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Empty Fields</span>
      <div class="grid gap-x-1 gap-y-0.5 grid-cols-[max-content_1fr] items-center">
        <span class="text-xs text-gray-600">Details on Terminal</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.detailsOnTerminalNotEmpty"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Translationstate Terminal</span>
      <div class="grid gap-3 mt-2">
        @for (translationState of translationStatesTerminal; track $index) {
          <label class="inline-flex items-center gap-1 text-xs text-gray-700">
            <input
              type="checkbox"
              [checked]="translationState[1]"
              (change)="toggleTranslationStateTerminal(translationState[0])"
              class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            />
            <span>{{ pascalCaseToWords(translationState[0]) }}</span>
          </label>
        }
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col">
      @if (!recyclingModeEnabled) {
        <span class="text-xs font-semibold text-gray-600 mb-2">DTCs</span>

        <div class="grid gap-x-1 gap-y-0.5 grid-cols-[max-content_1fr] items-center mb-5">
          <span class="text-xs text-gray-600">Assigned</span>
          <app-three-state-toggle
            [(ngModel)]="searchQuery.assignedDtcs"
            (stateChange)="onScopeChanged()"
            textTrue="Yes"
            textFalse="No"
          />
        </div>
      }
      <span class="text-xs font-semibold text-gray-600">Reviews</span>

      <div class="grid gap-x-1 gap-y-0.5 grid-cols-[max-content_1fr] items-center">
        <span class="text-xs text-gray-600">On-terminal reviewed by TR</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.mainLanguageTerminalFieldsReviewed"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Other</span>
      <div class="grid gap-3 mt-2">
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.mainLanguageTerminalFieldsExportedForReview"
            (change)="onScopeChanged()"
          />
          <span>Main lang. on-terminal fields exported for review</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [checked]="searchQuery.changesBy != undefined"
            (change)="changesByMe()"
          />
          <span>Changes by me</span>
        </label>
      </div>
    </div>

    <button
      type="button"
      class="ml-auto text-white bg-amazone-gray hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-1.5 cursor-pointer self-end"
      (click)="resetFilters()"
      appAgentAction
      agent="error-message-filter-reset"
      businessObject="errorMessage"
      action="reset"
    >
      Reset
    </button>
  </div>
</div>
